import { Button, Grid, Typography, Card, CardContent } from '@mui/material';
import React, { useContext } from 'react';
import Utils from '../../../../utils/Utils';
import Conversation from './Conversation';
import { RestauInfoContext } from '../../../../home/RestauInfoContext';
// import PhoneIcon from '@mui/icons-material/Phone';
// import EmailIcon from '@mui/icons-material/Email';
//import PropTypes from 'prop-types';

function DisplayBasicEventInfo(props) {
    const { form, formConfig, setOpenEditDialog, newEventPage } = props;
    const { restauHook } = useContext(RestauInfoContext);

    const getFieldValue = (field) => {
        const value = form[field.field_name];
        if (value === null || value === undefined || value === '') {
            return '-';
        }
        // Handle Firebase Timestamp objects
        if (
            value &&
            typeof value === 'object' &&
            value._seconds !== undefined
        ) {
            return new Date(value._seconds * 1000).toLocaleDateString();
        }

        // Handle Moment objects
        if (
            value &&
            typeof value === 'object' &&
            value._isAMomentObject === true
        ) {
            return value.format('MM/DD/YYYY');
        }

        // Handle other objects by converting to string
        if (typeof value === 'object') {
            return JSON.stringify(value);
        }

        return value;
    };

    return (
        <Grid container item spacing={2} sx={{ alignItems: 'flex-start' }}>
            <Grid
                item
                xs={12}
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography color="primary" variant="h6">
                    Event Info
                </Typography>
                <Button
                    size="small"
                    variant="outlined"
                    onClick={() => setOpenEditDialog(true)}
                >
                    Edit
                </Button>
            </Grid>

            <Grid item xs={12}>
                <Card variant="outlined">
                    <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                        <Grid container spacing={1.5}>
                            {formConfig.fields.map((field) => {
                                if (field.enable_field) {
                                    return (
                                        <Grid
                                            item
                                            xs={6}
                                            sm={4}
                                            md={3}
                                            lg={2}
                                            key={field.field_name}
                                        >
                                            <Typography
                                                variant="caption"
                                                color="text.secondary"
                                                sx={{
                                                    fontWeight: 'medium',
                                                    display: 'block',
                                                    mb: 0.25,
                                                }}
                                            >
                                                {field.field_label ||
                                                    field.field_name}
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                sx={{ lineHeight: 1.3 }}
                                            >
                                                {getFieldValue(field)}
                                            </Typography>
                                        </Grid>
                                    );
                                }
                                return null;
                            })}
                            {newEventPage ? null : (
                                <>
                                    <Grid item xs={6} sm={4} md={3} lg={2}>
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{
                                                fontWeight: 'medium',
                                                display: 'block',
                                                mb: 0.25,
                                            }}
                                        >
                                            Submitted On
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            sx={{ lineHeight: 1.3 }}
                                        >
                                            {Utils.convertTimestamp(
                                                form.submissionTimestamp,
                                                3,
                                                false,
                                                restauHook.restauTimeZone
                                            )}
                                        </Typography>

                                        {/* <Typography>
                                            Source : 
                                        </Typography>
                                        <Conversation /> */}
                                    </Grid>
                                    <Grid item xs={6} sm={4} md={3} lg={2}>
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{
                                                fontWeight: 'medium',
                                                display: 'block',
                                                mb: 0.25,
                                            }}
                                        >
                                            Source
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            sx={{ lineHeight: 1.3 }}
                                        >
                                            {form.source || '-'}
                                        </Typography>
                                    </Grid>
                                    <Conversation />
                                </>
                            )}
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
}

DisplayBasicEventInfo.propTypes = {};

export default DisplayBasicEventInfo;
